module.exports = {
    m: {
        lang: 'en',
        header: {
            product: 'PRODUCT',
            support: 'SUPPORT',
            roadmap: 'ROADMAP',
            forum: 'FORUM',
            buynow: 'Buy now',
        },
        footer: {
            title: 'SKYBOX All Rights Reserved.',
            term: 'Terms of Use',
            pri: "Privacy Policy",
            content: "Contact Us"
        },
        product: {
            title: "The best VR video player for all of us.",
            skyboxOne: 'SKYBOX&nbsp;',
            skyboxTwo: 'VR PLAYER',
            getapp: 'Get the App',
            magic: 'Stream&nbsp;',
            magicZero: ' Like Magic',
            magicOne: 'AirScreen uses state-of-the-art Wi-Fi technology so you can stream videos wirelessly',
            magicTwo: 'from your PC/Mac to your standalone VR devices without loss of quality.',
            magicThree: "You can also stream one video to multiple devices simultaneously.",
            magicFour: "Within a few clicks, stream your favorite videos from PC to the VR headsets.",
            support: "Support All&nbsp;",
            supportZero: ' VR Platforms',
            supportOne: 'SKYBOX supports nearly all VR platforms: Oculus Quest, Oculus Rift, Steam VR, Daydream, and so much more.',
            supportThree: "Most importantly, SKYBOX delivers the same amazing experience across all platforms.",
            envir: "Immersive 3D Environment",
            envirOne: "You can choose multiple VR theatres when you are watching 2D or 3D regular videos. Including Movie Theater, Space Station, Moon and Void, More are coming soon.",
            elegant: "Elegant User Experience",
            elegantOne: " ",
            eleOne: "SKYBOX is the most powerful and easy-to-use VR player.",
            eleTwo: "With our elegant design, many powerful features are just a few simple steps away.",
            all: "Support All&nbsp;",
            allOne: "Stereo Modes",
            allTwo: "SKYBOX supports all stereo modes, whether it is 2D or 3D, 180°or 360°. You can set stereo mode and various other parameters easily in SKYBOX.",
            engine: "Recognition Engine",
            engineOne: "Mostly, correct stereo modes will be automatically set by our intelligent recognition engine. So there is no need to figure out the correct stereo mode by yourself.",
            format: "Formats",
            formatOne: "SKYBOX can play nearly all video format, and provides several advanced settings you may need.",
            side: "2D, 3D-Side by Side, 3D-TopBottom 180°, 360°",
            sub: "Subtitles and Audio Tracks",
            eightk: "8K&nbsp;",
            sup: "Support",
            supOne: "SKYBOX supports UHD, 4K, AND 8K playback. On Quest 2, the maximum resolution supported is 8192x6144. You can stream in 8K using AirScreen, SMB or DLNA from your device.",
            enjoy: "Enjoy Your Videos With Local Media Server",
            enjoyOne: "SKYBOX supports streaming video from your UPnP/DLNA servers.",
            enjoyTwo: "Browse and play local videos remotely in VR via your home Wi-Fi network.",
            feat: "Features",
            featOne: "Support all video formats, UHD, 4K, 8K videos.",
            featTwo: "Support all video types, including 180° VR, 360° VR, 2D, and 3D.",
            featThree: "Support all VR platforms: Oculus, Vive, Gear VR, and Daydream.",
            featFour: "Supports browsing files by storage directory.",
            featFive: "Support subtitles and audio tracks selection.",
            featSix: "AirScreen: streaming local videos from PC to VR devices.",
            featSeven: "Automatically recognizes video type (180° VR, 360° VR, 2D, or 3D).",
            featEight: "Private folder: hides certain videos from device's gallery to only be viewed in SKYBOX.",
            featNine: " Advanced settings: tilt, scale, height, and aspect ratio.",
            featTen: "Amazing user interface and VR environment.",
            featEleven: "Various VR scenes while watching regular 2D and 3D videos.",
        },
        zendesk: {
            title: "Contact",
            name: "Your name",
            email: "Your E-mail address",
            qsO: "Select your VR device",
            qsT: "Choose a request type",
            dec: "For bug report, describe what went wrong and how you encountered the problem. \nFor feature request, describe what you would like SKYBOX to support and why.",
            sub: "Submit",
            fail: "The e-mail address is invalid.",
            null: "This field is required.",
            restitle: "Thank you for your inquiry.",
            container: "We are working on your question and will deliver a<br>response to the email you filled before.<br>Your feedback helps make SKYBOX better for everyone:)",
        },
        sedNav: {
            supportTitle: "Support",
            search: "Describe your issue",
            content: "Content",
        },
        sidebar: {
            fre: "Frequently Asked",
            havequsetion: "Have other questions?",
            submitticket: 'Submit a support ticket.',
        },
        supportTitle: {
            playback: '3D/180/360 Playback',
            frequently: 'Frequently Asked',
            features: 'Features',
            general: 'General',
        },
        get: {
            title: 'Get the App',
            vr: 'VR Devices',
            pc: 'PC / Mac Client',
            apk: 'APK Download',
            pre: 'Pre-installed',
            note: 'Release Notes',
            all: 'All Platforms',
            release: 'Release date:',
            // innerBox: {
            //     title: 'Choose the right version of Mac Client',
            //     containerOne: " SKYBOX Mac Client requires that macOS version is 10.13.x High Sierra or later. We have released different versions to support different macOS version.",
            //     containerTwo: "How to check macOS version:",
            //     containerThree: "From the Apple menu",
            //     containerFour: "in the corner of your screen, choose About This Mac.",
            //     btnOne: "macOS 11 & later",
            //     btnTwo: "Previous macOS",
            // }
            innerBox: {
                title: 'Choose the right version of Mac Client',
                containerOne: "SKYBOX Mac Client requires that macOS version is 10.11(El Capitan) or later.",
                containerTwo: "How to check macOS version and chip:",
                containerThree: "From the",
                containerFour: "menu in the corner of your screen, choose About This Mac.",
                btnOne: "M1&M2 chip",
                btnTwo: "Intel chip",
            }

        },
        content: {
            look: {
                title: "Why doesn’t it look right when the video is playing?",
                one: "Common VR video format is divided into 360 degrees, 180 degrees, 3D Top Bottom and 3D Side by Side. SKYBOX supports all of them and more.",
                two: "SKYBOX can automatically identify these formats, but sometimes automatic identification can make mistakes.",
                three: "When a wrong stereo mode occurs, please do the following:",
                four: "(1) Click on the “Stereo Mode” button on the right side of the control panel.",
                five: "(2) Click “Auto” to check whether the video is displayed correctly.",
                six: "(3) If the video does not seem right at the moment, click “Reset” in the “Stereo Mode” menu.",
                seven: "(4) Manually set to the correct stereo mode based on what you are viewing.",
                eight: "If it still doesn’t look right, maybe because the VR video has the wrong stereoscopic setting when it’s shooting. For that kind of videos, you can turn on the “Monoscopic Mode” in the top of the “Advanced Setting” panel, it will show only one of the picture to both eyes, so you won’t feel strange."
            },
            howair: {
                title: "How to use AirScreen?",
                one: "(1) Install the SKYBOX PC / Mac Client, you can download the application <a href='/get' style='color: #ffc820;'>&nbsp;here</a>",
                two: "(2) Ensure that the PC and mobile phones are on the same LAN (Wi-Fi) connection.",
                three: "(3) Open the SKYBOX PC / Mac Client, and click the “Open” button at the top left corner to add video. You can also drag & drop the video or folder directly to the interface.",
                four: "(4) Enter the AirScreen page of SKYBOX VR Player.",
                five: "(5) Click on “Search Device” and connect to the corresponding device.",
                six: "(6) Open the video and enjoy it.",
            },
            searchfor: {
                title: "Why can’t I search for devices or connect to my PC / Mac Client?",
                one: "(1) Check whether PC and mobile devices are in the same local area network (Wi-Fi) environment.",
                two: "(2) Check whether PC or mobile devices are using proxy servers, such as Express VPN, ShadowSocks, or Astrill.",
                three: "(3) Check whether the Windows firewall intercepted the SKYBOX PC / Mac Client. If so:",
                four: "<1> Open the “Control Panel”, enter the “Windows firewall” page.",
                five: "<2> Click “allow the application or function through the Windows firewall” on the left.",
                six: "<3> Add ticks to all “SKYBOX.exe”, then click “OK”.",
                seven: "If you still can not find or connect to PC, please reboot the devices and try again.",
            },
            videos: {
                title: "How to play videos on my local media server?",
                one: "SKYBOX supports streaming video from your local area network (LAN). Browse and play your videos easily in VR from your external Media Server.",
                two: " To play videos on your local media server, just simply launch SKYBOX and go to “Network” page, then you can see all your local network servers.",
                three: "And you can turn your PC into a streaming media server if you don’t have an external device. See <a href='/how-to-turn-on-media-streaming-in-windows/' style='color: #ffc820;'>How to Turn On Media Streaming in Windows?</a>",
            },
            media: {
                title: "How to turn on Media Streaming in Windows?",
                one: "(1) Open Windows Control Panel.",
                two: "(2) Type “media” in the search box, and choose “Media streaming options” from the result.",
                three: "(3) Click on “Turn on media streaming.”",
                four: "(4) Here you can give your media library a name.",
                five: "(5) Right click the videos file or folder, select “Include in Library” > “Videos.”",
                six: "If you want to turn off media streaming, just click on “Block All“ and click “OK.”",
            },
            updating: {
                title: "After updating SKYBOX to the newest version (v0.2.0 and after), I cannot access/play videos in the SMB folder?",
                one: "This may happen because there is a limit on the number of simultaneous users to access SMB share folder.",
                two: "Follow the steps below to change the setting in Windows 10:",
                three: "(1) Right click on the folder which you want to share and select “Properties”.",
                four: "(2) Choose the “Sharing” Tab and click on the “Advanced Sharing”.",
                five: "(3) Here set the “Limit the number of simultaneous users to” to 20 and click “Apply”.",
                six: "Reboot SKYBOX on your device and check if you can successfully playback videos on SMB share.",
                seven: "If videos still fail to playback , please drop us an email at <a href='mailto:contact@skybox.xyz' style='color: #ffc820;'>contact@skybox.xyz</a>",
            },

            adjust: {
                title: "How to adjust the position and size of the screen?",
                one: "To adjust the position and size of the screen, at first, you need to switch the environment to the VOID mode: Click on the “Cinema Scene” button on the right top of the control panel, and choose “VOID”.",
                two: "Then, point your cursor to the screen, move it by holding on the touchpad or trigger. And you can also slide up and down to adjust the screen size.",
                three: "Or you can tap the “Advanced Setting” button on the right of the control panel, then scroll up and manually set the “Tilt” and “Scale” options of the screen.",
            },
            hide: {
                title: "How can I hide a video from phone’s gallery?",
                one: "If you want to hide a certain video from your phone’s gallery app, you can just put it in the “Hide” folder under the Skybox directory. So that this video can only be displayed in SKYBOX app.",
            },
            load: {
                title: "How to load subtitles and select audio tracks?",
                one: "SKYBOX supports external text-based subtitle (.srt/.ssa/.ass/.smi/.txt) when you are watching a non-VR video. To load subtitles, you need to store the subtitle file and video file in the same folder and maintain the same file name (not including suffix).",
                two: "Then click on the “Subtitle and Track” button on the left side of the control panel, and select the corresponding subtitle.",
                three: "If your video has multiple audio tracks, you can click on the “Track” tab and select the corresponding audio track.",
            },
            phone: {
                title: "How to view the video in the phone?",
                one: "You can directly copy the video you want to play to the VR Device’s storage or SD card. Then the corresponding video in the application of the “All Files” page will be available.",
                two: "And SKYBOX can automatically recognize videos for VR mode, you can click on the “VR Videos” page to view all the VR videos on the deveice.",
            },
            show: {
                title: "Why some of my videos are not showing up?",
                one: "SKYBOX will automatically scan all the local videos, and display the video that can be played on “All Videos” page.",
                two: "If your video is not displayed on that page, perhaps it was considered as a video that can not be played, you can switch to “Directory” page to find the video by path.",
                three: "SKYBOX supports videos in MP4, Mkv, Avi, MOV, WMV, Rmvb, Flv, 3gp, WebM, VOB and so on. If you have not found your video in the “Directory” page, maybe because it is some format we don’t support now. We will continue to improve the video supportability.",
            },
            airscreen: {
                title: "What is AirScreen?",
                one: "AirScreen allows you to use the mobile VR devices, such as Gear VR, Daydream, or Oculus Go to watch videos within the PC, without the need of transmitting videos to the device, so as to save the device storage space and your time.",
                two: "You can download the application <a href='/get' style='color: #ffc820;'>&nbsp;here</a>",
            },
        }
    }
}